import { Box } from "@mui/material";
import ReactApexChart from "react-apexcharts";
import useColors from "../../../../../api/hooks/useColors";

const TopMCPServersChart = ({ mcpServersData }) => {
  const colors = useColors();

  const colorsChart = [
    colors.primary_300,
    colors.primary_200,
    colors.primary_100,
    colors.primary_50,
    colors.primary_25,
  ];

  const maxValue = Math.max(
    ...mcpServersData.map((server) => server.affected_entities_count),
    0
  );

  const getInterval = (value) => {
    if (value <= 50) return 5;
    if (value <= 100) return 10;
    return 50;
  };

  const interval = getInterval(maxValue);
  const maxYAxis =
    maxValue === 0 ? 10 : Math.ceil(maxValue / interval) * interval;
  const tickAmount = maxValue === 0 ? 5 : maxYAxis / interval;

  const apexSeries = [
    {
      name: "Affected Entities",
      data: mcpServersData.map((server, index) => ({
        x: server.display_name,
        y: server.affected_entities_count,
        fillColor: colorsChart[index % colorsChart.length],
      })),
    },
  ];

  const apexOptions = {
    chart: {
      type: "bar",
      height: 350,
      toolbar: { show: false },
      fontFamily: "inherit",
      id: "top-mcp-servers-chart",
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "32px",
        borderRadius: 4,
        borderRadiusApplication: "end",
      },
    },
    colors: [colors.primary_200],
    dataLabels: {
      enabled: false,
    },
    tooltip: {
      enabled: true,
      shared: true,
      intersect: false,
      custom: function ({ dataPointIndex }) {
        const server = mcpServersData[dataPointIndex];
        if (!server) return "";

        return `
          <div style="
            font-family: inherit;
            text-align: left;
            transform: translateX(-50%);
            position: relative;
            left: 50%;
            background: white;
            padding: 12px;
            border-radius: 4px;
            box-shadow: 0 2px 6px rgba(0,0,0,0.1);
            min-width: 160px;
          ">
            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px; gap: 4px;">
              <div style="font-size: 14px; color: ${
                colors.text_primary
              }; font-weight: 500; font-family: poppins;">
                ${server.display_name}
              </div>
            </div>
            ${
              server.platform
                ? `
            <div style="display: flex; flex-direction: row; align-items: center; justify-content: space-between; width: 100%; margin-bottom: 4px;">
              <div style="font-size: 12px; color: ${colors.text_secondary}; font-family: poppins;">
                Platform
              </div>
              <div style="font-size: 12px; color: ${colors.text_primary}; font-family: poppins;">
                ${server.platform}
              </div>
            </div>
            `
                : ""
            }
            
            <div style="display: flex; flex-direction: row; align-items: center; justify-content: space-between; width: 100%;">
              <div style="font-size: 12px; color: ${
                colors.text_secondary
              }; font-family: poppins;">
                Affected entities
              </div>
              <div style="font-size: 12px; color: ${
                colors.text_primary
              }; font-family: poppins;">
                ${server.affected_entities_count}
              </div>
            </div>
          </div>
        `;
      },
    },
    grid: {
      strokeDashArray: 4,
      borderColor: "rgba(145, 158, 171, 0.2)",
    },
    xaxis: {
      categories: mcpServersData.map((server) => server.display_name),
      labels: {
        style: {
          colors: colors.text_disabled,
          fontSize: "10px",
        },
        rotate: -45,
        rotateAlways: false,
        trim: true,
        maxHeight: 80,
      },
    },
    yaxis: {
      min: 0,
      max: maxYAxis,
      tickAmount: tickAmount,
      labels: {
        style: {
          colors: colors.text_disabled,
          fontSize: "10px",
        },
        formatter: (value) => Math.round(value),
      },
    },
    legend: {
      show: false,
    },
    states: {
      hover: { filter: { type: "none" } },
      active: { filter: { type: "none" } },
    },
  };

  return (
    <>
      <Box
        sx={{
          height: "270px",
          width: "100%",
          position: "relative",
        }}
      >
        <ReactApexChart
          key={`top-mcp-servers-chart-${mcpServersData.length}`}
          options={apexOptions}
          series={apexSeries}
          type="bar"
          height={270}
        />
      </Box>
    </>
  );
};

export default TopMCPServersChart;
